export default "__VITE_ASSET__NaUpk0m5__"